export class User {
  id: string;
  givenName: string;
  surname: string;
  initials: string;
  email: string;
  isAgreedTerms: boolean;
  accountEnabled: boolean;
  country: string;
  telephoneNumber: string;
  schemaVersion: string;
  tenantAttributes: UserTenantAttribute[];
}

export class UserTenantAttribute {
  id: string;
  name: string;
  role: string;
  isDefault: boolean;
}

export class UserSelectItem {
  id: string;
  givenName: string;
  surname: string;
}

export class UserEmailUpdate {
  email: string;
  password: string;
}

export class TenantUser {
  id: string;
  givenName: string;
  surname: string;
  initials: string;
  email: string;
  isSubscription: boolean;
  telephoneNumber: string;
  role:string;
}

export class TenantUserList {
  id: string;
  givenName: string;
  surname: string;
  email: string;
  role: string;
  accountEnabled: boolean;
  isActive: boolean;
  isSubscription: boolean;
  initials: string;
  telephoneNumber: string;

  getFullName(): string {
    return  this.givenName + ' ' + this.surname;
  }
}

export class UserDetail {
  id: string;
  givenName: string;
  surname: string;
  initials: string;
  email: string;
  telephoneNumber: string;
  isActive: boolean;
  isSubscription: boolean;
}

export class EmailItem {
  identifier: string;

  constructor(identifier: string) {
    this.identifier = identifier;
  }
}

export interface ProfileOffline {
  userId: string;
  tenantId: string;
  displayName: string;
  givenName: string;
  surname: string;
  role: string;
  uri: string;
  applicationProductRoles: string;
  isApplicationAdmin: number;
}
